import { render, staticRenderFns } from "./DepartmentNew.vue?vue&type=template&id=2538d078"
import script from "./DepartmentNew.vue?vue&type=script&lang=js"
export * from "./DepartmentNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports